export const Version = {
	version: '1.46.0-dev.18.245',
};
